import { Component, EventEmitter, Output } from '@angular/core';
import { MatFormField, MatInput } from '@angular/material/input';
import { IconComponent } from '../icon/icon.component';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { Observable } from 'rxjs';
import { SearchResult } from '../../../models/search-result';
import { selectGlobalSearchActive, selectGlobalSearchResults } from '../../../store/interface/interface.state';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { interfaceSetSearchTerm } from '../../../store/interface/interface.actions';
import { AsyncPipe } from '@angular/common';
import { MaterialModule } from '../../material/material.module';
import { Router } from '@angular/router';

@Component({
    selector: 'app-global-search',
    imports: [
    IconComponent,
    ReactiveFormsModule,
    AsyncPipe,
    MatFormField,
    MaterialModule
],
    templateUrl: './global-search.component.html',
    styleUrl: './global-search.component.scss'
})
export class GlobalSearchComponent {

    @Output()
    public close: EventEmitter<void> = new EventEmitter<void>();

    searchResults$: Observable<SearchResult[]>;
    searchActive$: Observable<boolean>;

    searchForm: FormGroup = new FormGroup({
        terms: new FormControl('')
    });

    constructor(private store: Store<AppState>, private router: Router) {
        this.searchResults$ = this.store.select(selectGlobalSearchResults);
        this.searchActive$ = this.store.select(selectGlobalSearchActive);
    }

    search(): void {
        this.store.dispatch(interfaceSetSearchTerm({ term: this.searchForm.get('terms').value }));
    }

    resultClick(result: SearchResult): void {
        this.router.navigate(result.route).then(() => this.close.emit());
    }
}
